/**
 * Supabase Client
 * 
 * This module provides the Supabase client for authentication and database operations.
 * Uses the official Supabase JavaScript client library.
 * 
 * Environment Variables Required:
 * - VITE_SUPABASE_URL: Your Supabase project URL
 * - VITE_SUPABASE_ANON_KEY: Your Supabase anonymous/public key
 */

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Missing Supabase environment variables. Please check your environment configuration.');
  console.error('Required variables: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY');
  console.error('For Docker: Ensure deployment/env/.env.dev or deployment/env/.env.prod exists with these variables');
  console.error('Current values:', {
    VITE_SUPABASE_URL: SUPABASE_URL ? 'SET' : 'MISSING',
    VITE_SUPABASE_ANON_KEY: SUPABASE_ANON_KEY ? 'SET' : 'MISSING',
  });
  throw new Error('Missing Supabase configuration');
}

// Validate URL format
if (SUPABASE_URL && !SUPABASE_URL.startsWith('http')) {
  console.error('Invalid SUPABASE_URL format. Should start with https://');
}

/**
 * Create Supabase client with authentication configuration
 */
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'iris-auth', // Unique key to prevent conflicts
  },
});
